import {ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync, RouterStateSnapshot} from "@angular/router";
import {inject, Injectable} from "@angular/core";
import {StateService} from "../Services/state/state.service";
import {Observable, of} from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TwixorChat implements CanActivate {
  stateService = inject(StateService);
  canActivate(): Observable<boolean> {
     return of(this.stateService.userInfo()?.twixor_enabled ?? false)
  }

}
